import { render, staticRenderFns } from "./Ingresos.vue?vue&type=template&id=bf6421a4&scoped=true&"
import script from "./Ingresos.vue?vue&type=script&lang=ts&"
export * from "./Ingresos.vue?vue&type=script&lang=ts&"
import style0 from "./Ingresos.vue?vue&type=style&index=0&id=bf6421a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6421a4",
  null
  
)

export default component.exports